import { Fragment, useState, useEffect } from 'react';
import { Dialog, Popover, Transition } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { mainRoutes } from '../../routes';
import { useAuth } from '../../Auth';
import { useNavigate } from 'react-router-dom';

import './Header.css'

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedin,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';


export default function Header() {

  // ------- Section of the code responsible for making the navbar visible whenever the user scrolls down ------- //
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrolledUp, setScrolledUp] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [showSubButtons, setShowSubButtons] = useState(false);

  const goTo = (path: string) => {
    window.location.href = path;
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show header only if scrolling up
      if (currentScrollY < lastScrollY && currentScrollY > 0) {
        setShowHeader(true);
        setScrolledUp(true);
      } else if (currentScrollY === 0) {
        setShowHeader(true);
        setScrolledUp(false); // at top, transparent
      } else {
        setShowHeader(false); // scrolling down
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  // ------- Section of the code responsible for making the navbar visible whenever the user scrolls down ------- //

  const navigate = useNavigate();

  const { isAuthenticated, username, first_name } = useAuth();

  const LogoWhite = require('./img/FNNLogoWithWhiteFont-07.png');
  const LogoBlack = require('./img/FNNLogoWithBlackFont-06.png');

  const [menuOpen, setMenuOpen] = useState(false);
  const handleAuthRedirection = () => {
    navigate('/login'); // Replace with your desired route
  };

  /* New menu */

  return (
    <Popover
      className={`header fixed top-0 w-full transition-all duration-300 
  ${showHeader ? 'translate-y-0' : '-translate-y-full'} 
  ${(scrolledUp || isHovered) ? 'bg-white bg-opacity-90' : 'bg-transparent'}`}
      style={{ zIndex: '10' }}
    >

      <div className="header-wrapper">{/* CHANGE HERE */}

        {/* Centered main nav */}
        <div
          className="testing-header"
          onMouseLeave={() => setIsHovered(false)}
        >

          <a href="/" className="header-left-side">
            <img className="fnn-header-logo" src={(scrolledUp || isHovered) ? LogoBlack : LogoWhite} alt="" />
          </a>

          <ul className="tesing-ul">
            {mainRoutes.map((route, index) =>

              <div key={index} className="relative group" onMouseEnter={() => setIsHovered(true)}>
                <div
                  className={`cursor-default ${(scrolledUp || isHovered) ? 'header-text' : 'header-text2'
                    }`}
                >
                  {route.name}
                </div>
              </div>

            )}

            {/* <li onMouseEnter={() => setIsHovered(true)}>Company</li>
            <li onMouseEnter={() => setIsHovered(true)}>Products</li>
            <li onMouseEnter={() => setIsHovered(true)}>Discover</li> */}
          </ul>

          <div className={`sub-item-div ${isHovered ? 'show' : ''}`}>
            <div className='sidebar-container'>
              <button
                className="sidebar-btn1"
                onClick={() => goTo('/about')}
              >
                About Us
              </button>

              <button
                className="sidebar-btn1"
                onClick={() => goTo('/login')}
              >
                Portal
              </button>


            </div>

            <div className="sidebar-container">
              <div className="hover-trigger">

                <button
                  className="sidebar-btn3"
                  onClick={() => goTo('/utility')}
                >
                  Utility Solutions
                </button>

                <button
                  className="sidebar-btn3"
                  onClick={() => goTo('/fire-agency')}
                >
                  Fire Agency Solutions
                </button>

                <button
                  className="sidebar-btn3"
                  onClick={() => goTo('/hrl-detector')}
                >
                  HRL Detector
                </button>

                {/* Hidden menu that appears on hover */}
                {/* <div className="mobile-sidebar1">
                  <button
                    className="sidebar-btn1"
                    style={{ marginLeft: '5.5rem' }}
                    onClick={() => {
                      window.location.href = '/hrl-utility';
                    }}
                  >
                    HRL Utility Solutions
                  </button>
                  <button
                    className="sidebar-btn1"
                    style={{ marginLeft: '6.4rem' }}
                    onClick={() => {
                      window.location.href = '/hrl-mapping';
                    }}
                  >
                    HRL Wildfire Solutions
                  </button>
                </div> */}
              </div>
            </div>

            <div className='sidebar-container'>

              <button
                className="sidebar-btn1"
                style={{ marginRight: '0.3rem' }}
                onClick={() => goTo('/careers')}
              >
                Careers
              </button>

              <button
                className="sidebar-btn1"
                style={{ marginRight: '0.3rem' }}
                onClick={() => goTo('/news')}
              >
                News
              </button>

              <button
                className="sidebar-btn1"
                style={{ marginRight: '0.3rem' }}
                onClick={() => goTo('/fountainn')}
              >
                FountaiNN
              </button>
            </div>
          </div>



          {/* Right side: auth + menu */}
          <div className="header-right-side">

            <button className='the-button-header'
              onClick={() => goTo('/contact')}>
              Contact Us
            </button>


            <div className='header-social-media'>
              <a
                href="https://www.youtube.com/@FNN_INC/videos"
                className={(scrolledUp || isHovered) ? "social-in-menu" : "text-gray-200 hover:text-white"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} size="2x" />
              </a>

              <a
                href="https://www.linkedin.com/company/fnninc/"
                className={(scrolledUp || isHovered) ? "social-in-menu" : "text-gray-200 hover:text-white"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>

              <a
                href="https://x.com/_FNNINC"
                className={(scrolledUp || isHovered) ? "social-in-menu" : "text-gray-200 hover:text-white"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faXTwitter} size="2x" />
              </a>

            </div>

            <div
              onClick={() => setMenuOpen(!menuOpen)}
              className="header-menu"
            >
              <Bars3Icon className="h- w-5" aria-hidden="true" />
            </div>
          </div>
        </div>

      </div>

      <Transition.Root show={menuOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setMenuOpen}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen h-full max-w-md">
                    <div className="menu-side-bar ">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <div className="flex h-7 items-center">
                            <button
                              type="button"
                              className="rounded-md text-gray-400 hover:text-red-600 focus:outline-none cursor-pointer"
                              onClick={() => setMenuOpen(false)}
                            >
                              <XMarkIcon
                                className="h-6 w-6"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 w-full px-8 sm:px-6">
                        <ul className="my-menu-ul">
                          {/* Loop through the main routes */}
                          {mainRoutes.map((menuItem, index) => (
                            <li key={index} className="menu-item" onClick={() => setMenuOpen(false)}>
                              <span className="menu-link nothing">{menuItem.name}</span>

                              {menuItem.subRoutes && (
                                <ul className="sub-menu">
                                  {menuItem.subRoutes.map((subItem, subIndex) => {
                                    const linkText = subItem.name

                                    return (
                                      <li key={subIndex} className="sub-menu-item">

                                        <a href={subItem.to}
                                          className="menu-link sub"
                                        >
                                          {linkText}
                                        </a>
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                            </li>
                          ))}


                          <a href="/contact" className='the-button-menu' onClick={() => setMenuOpen(false)}>
                            <p>Contact Us</p>
                          </a>

                          <div className='header-social-media-in-menu'>
                            <a
                              href="https://www.youtube.com/@FNN_INC/videos"
                              className="social-in-menu"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FontAwesomeIcon icon={faYoutube} size="2x" />
                            </a>

                            <a
                              href="https://www.linkedin.com/company/fnninc/"
                              className="social-in-menu"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FontAwesomeIcon icon={faLinkedin} size="2x" />
                            </a>

                            <a
                              href="https://x.com/_FNNINC"
                              className="social-in-menu"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FontAwesomeIcon icon={faXTwitter} size="2x" />
                            </a>

                          </div>

                        </ul>
                      </div>

                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </Popover>
  );
}
